import { render, staticRenderFns } from "./AgentSummary.vue?vue&type=template&id=bec3f10c&scoped=true&"
import script from "./AgentSummary.vue?vue&type=script&lang=js&"
export * from "./AgentSummary.vue?vue&type=script&lang=js&"
import style0 from "./AgentSummary.vue?vue&type=style&index=0&id=bec3f10c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec3f10c",
  null
  
)

export default component.exports